import type { CSSProperties } from 'react';

import { cx } from '../cx';

/** Bloc gris animé pendant un chargement ; masqué aux lecteurs d'écran. */
export function Skeleton({ width = '100%', height = 14, className }: { width?: CSSProperties['width']; height?: CSSProperties['height']; className?: string }) {
  return <span className={cx('ui-skeleton', className)} style={{ width, height }} aria-hidden="true" />;
}
